import { Controller } from "@hotwired/stimulus"
import { Sortable } from 'sortablejs'
import { put } from '@rails/request.js'

// Connects to data-controller="conversion-events-sort"
export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: '.sortable-handle',
      // A row without an update URL belongs to another account and cannot move.
      // newDraggableIndex counts only the rows that can move, so the position
      // the server receives ignores the other rows.
      draggable: '[data-update-url]',
      onUpdate: (event) => {
        let url = event.item.dataset.updateUrl;

        put(url, { body: { position: event.newDraggableIndex }})
      }
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }
}
